import "../App.css";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import WarningIcon from "@mui/icons-material/Warning";
import blogo from "./blogo.png";
import { useTheme } from "@mui/material/styles";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";

export default function Navbar(props) {
  const theme = useTheme();
  return (
    <>
      <Box className="mainNavBox" sx={{ flexGrow: 1 }}>
        <AppBar
          color={props.prevYr ? "warning" : "info"}
          enableColorOnDark={props.prevYr}
          position="static"
        >
          <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              <img
                src={blogo}
                height="30"
                className="navImg"
                style={{
                  filter:
                    theme.palette.mode === "dark" && props.prevYr
                      ? "invert(1)"
                      : "none",
                }}
              />{" "}
              Bialik Student Profiles
            </Typography>
            {props.prevYr && (
              <Typography
                variant="h6"
                component="div"
                sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}
              >
                <WarningIcon sx={{ marginRight: 1 }} /> You are viewing data
                from the {props.prevYr} school year.
              </Typography>
            )}

            <div>
              <IconButton
                aria-label="Toggle dark mode"
                color="inherit"
                onClick={props.toggleTheme}
              >
                {theme.palette.mode === "dark" ? (
                  <Brightness7Icon />
                ) : (
                  <Brightness4Icon />
                )}
              </IconButton>
              <IconButton
                aria-label="Help"
                color="inherit"
                onClick={() => props.setHelpOpen([true, "help"])}
              >
                {" "}
                <QuestionMarkIcon />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
      </Box>
    </>
  );
}
